import React from "react";

const ComplaiChat = () => {
  return <div>ComplaiChat</div>;
};

export default ComplaiChat;
